import React from 'react';
import { getProListingFeeSummary, getPracticeProListingFeeSummary } from 'api/financials';
import { TProListingFeeSummary } from 'types/financials';

const globalData: Partial<Record<'my' | 'practice', TProListingFeeSummary>> = {};

const useProlistingFeeSummary = (
    timeRangeMonths?: number,
    isPractice = false,
): [TProListingFeeSummary | undefined, boolean, () => void] => {
    const scope = isPractice ? 'practice' : 'my';
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TProListingFeeSummary | undefined>(globalData[scope]);
    const fetchData = async () => {
        try {
            setLoading(true);
            const request = isPractice ? getPracticeProListingFeeSummary : getProListingFeeSummary;
            const result = await request(timeRangeMonths || 0);
            if (!result.error) {
                const data: TProListingFeeSummary = result?.data?.data;
                globalData[scope] = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (timeRangeMonths !== undefined) {
            fetchData();
        }
    }, [timeRangeMonths, isPractice]);

    return [items, loading, fetchData];
};

export default useProlistingFeeSummary;
